import React, { useEffect, useState } from "react";
import {
  getComputerSkillCategory,
  getComputerSkillCategories,
  setComputerSkillCategory,
  deleteComputerSkillCategory,
} from "../../services/dictionary";
import Lists from "../../modules/hcmd/components/Lists";
import { useParams } from "react-router-dom";
import Forms from "../../modules/hcmd/components/Forms";
import { usePermission } from "../../services/auth";

ComputerSkillCategories.propTypes = {};

function ComputerSkillCategories(props) {
  let { id } = props;

  const [isForm, setIsForm] = useState(false);

  const permissions = usePermission("dictionary");
  const params = useParams();
  if (!id && !isNaN(parseInt(params.id)) && parseInt(params.id) >= 0) {
    id = parseInt(params.id);
    if (!isForm) {
      setIsForm(true);
    }
  } else if (!isNaN(parseInt(id)) && parseInt(id) >= 0 && !isForm) {
    setIsForm(true);
  } else if (isForm) {
    setIsForm(false);
  }

  // ide jonnek a tipusnal hasznalt egyeb adatok deklaralasa

  // ide jon az oszlopok deklaralasa
  const columns = [
    {
      field: "id",
      fieldType: "number",
      hide: true,
    },
    {
      field: "name",
      fieldType: "text",
      headerName: "Megnevezés",
      validation: {
        required: true,
        minLength: 3,
      },
    },
    {
      field: "priority",
      fieldType: "number",
      // editable: false,
      defaultValue: 1,
      headerName: "Prioritás",
      width: 100,
    },
    {
      field: "isActive",
      fieldType: "boolean",
      defaultValue: true,
      headerName: "Státusz",
      width: 100,
      valueGetter: (params) => {
        return params.row.isActive ? "aktív" : "inaktív";
      },
    },
  ];

  // ide jon a fejlec deklaralasa
  const header = {
    title: "Számítógépes ismeret kategóriák",
    url: "/dictionary/computer-skill-categories",
    item: "számítógépes ismeret kategória",
  };

  return (
    <>
      {isForm && (
        <Forms
          editable={true}
          id={id}
          header={header}
          permissions={permissions}
          columns={columns}
          getFunc={getComputerSkillCategory}
          setFunc={setComputerSkillCategory}
        ></Forms>
      )}
      {!isForm && (
        <Lists
          header={header}
          permissions={permissions}
          getFunc={getComputerSkillCategories}
          isDictionary={true}
          deleteFunc={deleteComputerSkillCategory}
          columns={columns}
        ></Lists>
      )}
    </>
  );
}

export default ComputerSkillCategories;
